class FloatingDropdownManager {
  attach(anchor, dropdown, options = {}) {
    if (!anchor || !dropdown || !anchor.closest(".modal-body")) {
      return () => {};
    }

    const update = () => {
      const above = this.position(anchor, dropdown, options);
      options.onPosition?.(above);
    };
    update();
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);

    return () => {
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
      dropdown.style.visibility = "";
    };
  }

  position(anchor, dropdown, options) {
    const rect = anchor.getBoundingClientRect();
    const height = dropdown.offsetHeight;
    const offset = options.offset ?? 0;
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = Boolean(options.allowAbove) && spaceBelow < height + offset && rect.top >= height + offset;
    const body = anchor.closest(".modal-body").getBoundingClientRect();
    const outOfView = rect.bottom <= body.top || rect.top >= body.bottom;

    Object.assign(dropdown.style, {
      position: "fixed",
      top: (above ? rect.top - height - offset : rect.bottom + offset) + "px",
      bottom: "auto",
      left: rect.left + "px",
      right: "auto",
      zIndex: "1060",
      visibility: outOfView ? "hidden" : "visible",
    });

    if (options.matchWidth) {
      dropdown.style.width = rect.width + "px";
      dropdown.style.minWidth = rect.width + "px";
    }

    return above;
  }
}

export const floatingDropdownManager = new FloatingDropdownManager();
